import trim from 'lodash/trim';

type Values = {
  postCode: string,
  searchText: string,
};

export const validate = (
  { postCode, searchText }: Values,
  deniedAccess: boolean,
  error?: any,
  t: function,
  isNavigatorGeolocation?: boolean,
  isAddressSelected?: boolean
): {} => {
  const errors = {};

  if (!postCode && deniedAccess) {
    errors.postCode = t('deniedPermission');
    errors.searchText = t('deniedPermission');
    return errors;
  }

  if (error) {
    errors.postCode = t('wrongPostcode');
    errors.searchText = t('wrongPostcode');
    return errors;
  }

  if (!isAddressSelected && !trim(postCode) && !trim(searchText) && !isNavigatorGeolocation) {
    errors.postCode = t('validations:isRequired');
    errors.searchText = t('validations:isRequired');
  }

  return errors;
};
